export function formatNumber(value) {
    // Remove all non-numeric characters

    let cleanValue = String(value).replace(/\D/g, "");
    // Add commas as thousand separators
    return cleanValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function removeCommas(value) {
    // Remove commas and return raw numeric value
    return value.replace(/,/g, "");
}
